/* istanbul ignore file */
import { array as codecArray, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PutDescriptionAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['file', /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(parsers.file))],
]);
export class PutDescriptionAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutDescriptionAssignmentDataParser.decode(input).map(res => new PutDescriptionAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PutDescriptionAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutDescriptionAssignmentDataParser.encode(data);
    }
    static schema() {
        return PutDescriptionAssignmentDataParser.schema();
    }
}
